import { defineMessages } from "react-intl";
import { BaseObjLabels } from "../base-obj";

/**
 * Localized labels for ClientGroup fields
 */
export const ClientGroupLabels = {
  ...BaseObjLabels,
  // Add AuthorEditorFields if needed
  ...defineMessages({
    // organizationId <- not used, ignoring
    name: {
      defaultMessage: "name",
      description:
        "Field label for device client group name (ClientGroup.name)"
    },
    type: {
      defaultMessage: "type",
      description:
        "Field label for device client group type (ClientGroup.type)"
    },
    description: {
      defaultMessage: "description",
      description:
        "Field label for device client group description (ClientGroup.description)"
    },
    entitlements: {
      defaultMessage: "entitlements",
      description:
        "Field label for device client group entitlements (ClientGroup.entitlements)"
    }
  })
};


export const ClientGroupValues = {
  name: defineMessages({
    undefined: {
      defaultMessage: "Unknown",
      description:
          "Fallback value for missing device client group name (ClientGroup.name undefined)"
    }
  })
};
